import React from "react";
import { WebsiteIcon } from "assets";
import LogoBaseLink from "./LogoBaseLink";

const SpotlightPerformerWebsiteLogoLink: React.FC<
  React.PropsWithChildren<{
    href: string;
    webSiteLabel: string;
    tabIndex?: number;
  }>
> = ({ href, webSiteLabel, tabIndex = 0 }) => {
  return (
    <LogoBaseLink href={href} tabIndex={tabIndex}>
      <span className="c-social-media-list__icon">
        <WebsiteIcon />
      </span>
      <span className="c-social-media-list__label">{webSiteLabel}</span>
    </LogoBaseLink>
  );
};

export default SpotlightPerformerWebsiteLogoLink;
